<ng-container *ngIf="type === 'files'; else elseBlock">
  <div appDnd class="dropzone dropzone-file" [ngStyle]="{ height: '150px', width: '100%' }" (filesChangeEmitter)="onFileChangeFile($event)">
    <input type="file" id="input-files-image" class="d-none" (change)="onFileChange($event)" />

    <ng-container *ngIf="(fileUrl | async) && !isLoading.value"></ng-container>
    <ng-container *ngIf="isLoading.value">
      <div class="d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading.value">
      <label for="input-files-image" class="d-flex cursor-pointer align-items-center justify-content-center flex-column">
        <img [src]="STRING_CONSTANTS.ICON.IC_UPLOAD_FILE" alt="upload_icon" />
        <span class="mt-4 fw-semibold text-gray-800">Drag files here of click to upload, <br />or <span class="text-info">browse</span>.</span>
      </label>
    </ng-container>
  </div>
</ng-container>
<ng-template #elseBlock>
  <ng-container [ngSwitch]="style">
    <ng-container *ngSwitchCase="'Theme1'">
      <ng-container *ngTemplateOutlet="Theme1"></ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="DefaultStyle"></ng-container>
    </ng-container>

    <ng-template #DefaultStyle>
      <div appDnd class="dropzone" [ngStyle]="{ height: '176x', width: '176px' }" (filesChangeEmitter)="onFileChangeFile($event)">
        <input type="file" id="input-files" class="d-none" (change)="onFileChange($event)" accept="image/*" />

        <ng-container *ngIf="isLoading.value">
          <div>Loading</div>
        </ng-container>

        <ng-container *ngIf="!isLoading.value">
          <label for="input-files" class="d-flex cursor-pointer align-items-center justify-content-center flex-column">
            <img [src]="STRING_CONSTANTS.ICON.IC_PLUS_IMAGE_UPLOADER" alt="upload_icon" />
            <span class="mt-4 text-gray-400">Add image here</span>
          </label>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #Theme1>
      <div class="d-flex flex-wrap align-items-start mb-6">
        <label *ngIf="showLabel" class="col-12 col-lg-4 col-form-label" [class.required]="required">{{ label }}</label>
        <div [class.ms-auto]="greaterThanZero(idx)" class="col-12" [ngClass]="{ 'col-lg-8': showLabel || greaterThanZero(idx) }">
          <ng-container *ngIf="(fileUrl$ | async) && !isLoading.value; else uploaderTpl">
            <div class="dropzone dropzone-{{ style }} dropzone-panel" style="border-width: 2px">
              <ng-container [ngTemplateOutlet]="previewImage" [ngTemplateOutletContext]="{ url: fileUrl.value }"></ng-container>

              <ng-container *ngIf="enableDelete && fileUrl.value">
                <input type="file" id="input-image__{{ idx }}" class="d-none" (change)="onFileChange($event)" accept="image/jpg, image/jpeg, image/png" />

                <label for="input-image__{{ idx }}" class="cursor-pointer mt-4">
                  <span class="text-decoration-underline caption fw-bold mt-n6">{{ ctaLabelFile }}</span>
                </label>
              </ng-container>
            </div>
          </ng-container>

          <ng-template #uploaderTpl>
            <div appDnd class="dropzone dropzone-{{ style }} dropzone-panel" [class.error]="hasError" (filesChangeEmitter)="onFileChangeFile($event)">
              <input
                type="file"
                id="input-image__{{ idx }}"
                class="d-none"
                (change)="onFileChange($event)"
                accept="image/jpg, image/jpeg, image/png"
                [disabled]="isDisabled"
                [class.disabled]="isDisabled"
              />

              <ng-container *ngIf="isLoading.value">
                <ng-container *ngTemplateOutlet="loaderSpinner"></ng-container>
              </ng-container>

              <label
                for="input-image__{{ idx }}"
                class="d-flex align-items-center justify-content-center flex-column mt-6"
                [class.cursor-pointer]="enableDelete"
                *ngIf="!isLoading.value"
              >
                <ng-container *ngIf="!fileUrl.value">
                  <ng-container *ngIf="hasError; else defaultIconUpload">
                    <span class="svg-icon" [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER"></span>
                  </ng-container>

                  <ng-template #defaultIconUpload>
                    <span class="svg-icon svg-icon-uploader" [inlineSVG]="STRING_CONSTANTS.ICON.IC_UPLOAD_FILE"></span>
                  </ng-template>

                  <span class="my-6 fw-bold">
                    <ng-container *ngIf="hasError; else defaultTextUpload">
                      <div [innerHTML]="errorMessage"></div>
                      <span class="text-info-text text-decoration-underline d-block mt-4">{{ ctaLabelFile }}</span>
                    </ng-container>

                    <ng-template #defaultTextUpload>
                      Drag file here or click to upload,<br />
                      or <span class="text-info-text">browse</span>.
                    </ng-template>
                  </span>
                </ng-container>
              </label>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #loaderSpinner>
  <div class="d-flex cursor-pointer align-items-center justify-content-center">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</ng-template>

<ng-template #previewImage let-url="url">
  <div class="position-relative mw-100 m-auto" [ngStyle]="{ width: '50%' }">
    <span *ngIf="enableDelete" class="img-close-icon" [inlineSVG]="STRING_CONSTANTS.ICON.IC_BULLET_CLOSE" (click)="onRemoveFile()"></span>
    <img [src]="url" alt="preview" class="img-thumbnail img-fluid p-2" />
  </div>
</ng-template>
